module.exports = __webpack_public_path__ + "img/robin.52bb8c41.png";